import { render, staticRenderFns } from "./site-notes-section.vue?vue&type=template&id=2353d16d&scoped=true&"
import script from "./site-notes-section.vue?vue&type=script&lang=js&"
export * from "./site-notes-section.vue?vue&type=script&lang=js&"
import style0 from "./site-notes-section.vue?vue&type=style&index=0&id=2353d16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353d16d",
  null
  
)

export default component.exports